import { render, staticRenderFns } from "./mailGruppo.vue?vue&type=template&id=85724568&scoped=true&"
import script from "./mailGruppo.vue?vue&type=script&lang=js&"
export * from "./mailGruppo.vue?vue&type=script&lang=js&"
import style0 from "./mailGruppo.vue?vue&type=style&index=0&id=85724568&scoped=true&lang=css&"
import style1 from "./mailGruppo.vue?vue&type=style&index=1&lang=css&"
import style2 from "./mailGruppo.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85724568",
  null
  
)

export default component.exports